module.exports = __webpack_public_path__ + "img/thumb-itsybatsy.ac22b6ee.png";